import React from 'react';
import GenericPagination from '@components/common/generic-pagination/generic-pagination';
import { FAV_CONSTANTS } from '@constants/favorites';
import { HotFiltersPaginationState } from '@interfaces/api/responses/hot-filters.response';

type FavoritesPaginationProps = {
  pageType: string;
  paginationMeta: HotFiltersPaginationState;
  handlePaginationChange: (page: number, itemsPerPage: number) => void;
  handleItemsPerPageClick: (count: number) => void;
  itemsPerPage: number;
};

const FavoritesPagination: React.FC<FavoritesPaginationProps> = ({
  pageType,
  paginationMeta,
  handlePaginationChange,
  handleItemsPerPageClick,
  itemsPerPage,
}) => {
  return (
    <GenericPagination
      pageType={pageType}
      paginationMeta={paginationMeta}
      defaultLimit={FAV_CONSTANTS.FAV_DEFAULT_LIMIT}
      handlePaginationChange={handlePaginationChange}
      handleItemsPerPageClick={handleItemsPerPageClick}
      itemsPerPage={itemsPerPage}
      dataCyPagination={{
        container: 'favorite-pagination-container',
        resultsLabel: 'favorite-results-label',
        resultsItem: 'favorite-results-item',
      }}
    />
  );
};

export default FavoritesPagination;
